<script>
export default {
  props: {
    cartRoute: String,
    checkoutRoute: String,
    hiddenMd: [String, Boolean],
    cartId: String,
  },
};
</script>

<template lang='pug'>
.w-full.transition-all.transition-250(v-if='cartId', :class='[hiddenMd ? "block md_hidden" : "hidden md_block"]')
  .flex.justify-between.items-center.w-20.md_w-16.mx-auto.mt-2_5.text-brand-secondary-850

    router-link.text-lg.md_text-sm.font-bold.select-none.checkout-step(
      :to='{ name: cartRoute, params: { id: cartId } }',
    ) Shopping Bag

    .border-t.flex-grow.border-dashed.mx-1.border-border

    router-link.text-lg.md_text-sm.font-bold.select-none.checkout-step(
      :to='{ name: checkoutRoute }',
    ) Checkout
</template>

<style>
@import '~import/index';

.checkout-step {
  &:hover {
    text-decoration: underline;
  }

  &.router-link-exact-active {
    color: $primaryColor;
    text-decoration: none;
    cursor: default;
  }
}
</style>